import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Check, ArrowUpRight } from 'lucide-react';
import { api } from '../lib/api';
import { mergeOffers, UPSELL_TIERS } from '../lib/offers';

// Index of upsell offers. Each card links to its own sub-landing (/upgrade/:tier).
export default function OfferGrid({ tiers = UPSELL_TIERS }) {
  const navigate = useNavigate();
  const [config, setConfig] = useState({});

  useEffect(() => { api.publicConfig().then(setConfig).catch(() => {}); }, []);

  const offers = mergeOffers(config).filter((o) => tiers.includes(o.key));

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4" data-testid="offer-grid">
      {offers.map((t) => (
        <div
          key={t.key}
          data-testid={`offer-card-${t.key}`}
          className={`group relative flex flex-col rounded-2xl border p-6 transition-transform duration-300 hover:-translate-y-1 ${t.highlight ? 'border-node-style/60 bg-node-style/[0.06]' : 'border-border bg-card hover:border-white/25'}`}
        >
          <h3 className="text-lg font-semibold text-white">{t.name}</h3>
          <div className="mt-2 flex items-baseline gap-1.5">
            <span className="font-serif-display text-3xl text-white">{t.price}</span>
            <span className="text-xs text-muted-foreground">{t.cadence}</span>
          </div>
          <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{t.tagline}</p>
          <ul className="mt-4 flex-1 space-y-2">
            {t.features.map((f) => (
              <li key={f} className="flex items-start gap-2 text-xs text-white/70">
                <Check size={13} className="mt-0.5 shrink-0 text-node-environment" />{f}
              </li>
            ))}
          </ul>
          <button
            onClick={() => navigate(`/upgrade/${t.key}`)}
            data-testid={`offer-view-${t.key}`}
            className={`mt-5 inline-flex items-center justify-center gap-1.5 rounded-full px-4 py-2.5 text-sm font-medium transition-colors ${t.highlight ? 'bg-white text-black hover:bg-white/90' : 'border border-white/20 bg-white/5 text-white hover:bg-white/10'}`}
          >
            View offer <ArrowUpRight size={15} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </button>
        </div>
      ))}
    </div>
  );
}
